<template>

  <div class="bg-container page">
    <img class="bg-img" v-if="$store.getters.getBaseInfo.login_bg" :src="$store.getters.getBaseInfo.login_bg" />
    <!-- <img class="bg-img" src="@/assets/login-bg.png" /> -->
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#d7d7d7" @click="back()"/>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:''">
            </div>
          </div>
          <!-- <div class="title">{{$t("auth.register")}}</div> -->
          <div class="loginForm">
            <van-field v-model="username"  clearable  class="input"  :placeholder="$t('auth.username_place')" />
            <van-field
                v-model="password"
                :type="passwordType"
                class="input"
                :placeholder="$t('auth.pwd_place')">
              <template slot="right-icon">
                <van-icon color="#d1af6f" :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
            </van-field>
            <van-field v-model="code"  clearable class="input"  :placeholder="$t('auth.invite_code_place')" />
            <div class="agreement">
              <van-checkbox v-model="checked"  checked-color="#d1af6f" > <span class="agreement-text">{{$t("auth.agreement_place")}}</span></van-checkbox>
             
            </div>
            <van-button class="login-btn"  :class="{'active':username && password && code}" :disabled="isDisabled" type="primary" size="normal" @click="doRegister()">{{$t("auth.register")}}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: '',
      password: this.inputValue,
      passwordType: 'password',
      isDisabled:false
    };
  },
  mounted(){
    this.lang = localStorage.getItem("viodeLang") || this.$store.state.langDefault;
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.isDisabled = true
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res=>{
        if (res.code === 200) {
            this.$toast.success(res.msg);
            localStorage.setItem("tokensso", res.data.tokensso);
            localStorage.setItem('token',res.data.id)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
        }
          this.isDisabled = false
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register{
  height: 100%;
}
.bg-container .bg-wrapper .register .nav-bar{
  background: 0 0
}
.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper{
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  opacity: 0.8;
}
.register .wrapper .title{
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #d1af6f;
  letter-spacing: 5px;
}
.register .wrapper .loginForm{
  padding: 60px;
}
.register .wrapper .loginForm .input{
  padding: 10px 20px;
  margin-top: 35px;
  border-radius: 50px;
  text-align: center;
  line-height: 70px;
  font-size: 30px;
  color: #d1af6f;
  background-color: rgba(0, 0, 0, .5);
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.register .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.register .wrapper .loginForm .reset-text span{
  color: #d1af6f;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.register .wrapper .loginForm .register-text{
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .register-text span{
  color: #d1af6f;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}

.register .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 100px;
    background-color: #cacacc;
    border-radius: 10px;
    color: #d1af6f;
    font-size: 24px;
    font-weight: bolder;
    border: none;
    border-radius: 50px;
}
.register .wrapper .loginForm .active {
  color: #ffffff;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
}

::v-deep .register .wrapper .van-field__control, .login .wrapper .van-field__control{
  color: #fff !important;
  font-size: 24px;
}
.register .wrapper .loginForm .agreement{
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .agreement .agreement-text{
  // margin-left: 10px;
  font-size: 24px;
  color: #ffffff;
  font-weight: 500;
  line-height: 30px;
}
::v-deep .agreement .van-icon {
  font-size: 30px;
}
::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}
::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  // color: #d1af6f;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}
</style>
